import {Icon} from '@/app/components/Icon';
import {cn} from '@/lib/utils';
import {useGetPhraseFileQuery} from '../../../app/services/fileApi';
import {BiobookPage} from '../types';
export interface BiobookPageImageProps {
  biobookPage: BiobookPage;
  className?: string;
  containerClassName?: string;
  figCaption?: string;
  fileName: string;
  onClick?: () => void;
}
export const BiobookPageImage = ({
  biobookPage,
  className,
  containerClassName,
  figCaption,
  fileName,
  onClick,
}: BiobookPageImageProps) => {
  const {
    data: fileThumb,
    error: errorFileThumb,
    isFetching: isFetchingFileThumb,
  } = useGetPhraseFileQuery({
    fileName,
    phraseId: biobookPage.phraseId,
    thumb: true,
  });
  return (
    <div className={containerClassName} title={fileName}>
      <div
        className={cn(
          'flex items-center justify-center w-[8rem] h-[8rem] rounded-md border border-zinc-400 p-1',
          className,
          {
            'cursor-pointer hover:border-zinc-600': !isFetchingFileThumb && !errorFileThumb && fileThumb,
          },
        )}
        onClick={() => !isFetchingFileThumb && !errorFileThumb && fileThumb && onClick?.()}
        role="button"
      >
        {isFetchingFileThumb && <Icon icon="spinner" spin />}
        {!isFetchingFileThumb && errorFileThumb && <Icon icon="ban" />}
        {!isFetchingFileThumb && !errorFileThumb && fileThumb && (
          <img alt="" className="max-w-full max-h-full" src={fileThumb} />
        )}
      </div>
      {figCaption && <figcaption className={'p-2 text-center text-sm italic'}>{figCaption}</figcaption>}
    </div>
  );
};
